import React, { Fragment, useState } from 'react';
import Header from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import aImg from '../../images/about/about_image_3.webp'
import about from '../../images/clients/about.png'
import journey from '../../images/clients/journey.png'
import aImg2 from '../../images/about/about_image_4.webp'
import ModalVideo from 'react-modal-video'
import PolicySection from './Policy';
import WhyUs from './WhyUs';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import CtaSection from '../../components/CtaSection/CtaSection';


const AboutUsPage = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'About Us'} pagesub={'More Panca Pilar Laksana'} pageTop={'About'} />
                <section className="intro_about_section section_space bg-light">
                    {/* <div className="intro_about_content">
                        <div className="container">
                            <div className="col-lg-12">
                                <div className="image_wrap d-flex justify-content-center">
                                    <img src={about} alt="Panca Pilar Laksana - About " style={{ borderRadius: 20 }} />
                                </div>
                            </div>

                        </div>
                    </div> */}
                    <div className="container">
                        <div className="heading_block mb-0">
                            <div className="row justify-content-lg-between">
                                <div className="col-lg-4">
                                    <div className="heading_focus_text">
                                        About
                                        <span className="badge bg-secondary text-white">Panca Pilar Laksana</span>
                                    </div>
                                    <h2 className="heading_text mb-0">
                                        Why Panca Pilar Laksana
                                    </h2>
                                </div>
                                <div className="col-lg-6">
                                    <p className="heading_description mb-0">
                                        At Panca Pilar Laksana, we pride ourselves on offering dynamic and  IT  to suit your specific requirements. Our flexible approach means we can  adjust our offerings to accommodate your evolving needs, whether you require comprehensive IT infrastructure support, strategic consultancy, software development
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="intro_about_section bg-light">
                    <div className="container">
                        <div className="col-lg-12">
                            <div className="image_wrap d-flex justify-content-center">
                                <img src={journey} alt="Panca Pilar Laksana - About " style={{ borderRadius: 20, width: 1000 }} />
                            </div>
                        </div>

                    </div>
                </section>
                {/* <PolicySection /> */}
                {/* <FeaturesSection /> */}
                <TeamSection />
                {/* <WhyUs /> */}
                {/* <CtaSection /> */}
            </main>
            <Footer />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default AboutUsPage;
